import { wcWizardEnabled } from "@/config";
import type { LineOfBusiness } from "@/lib/brokerProducts";

// Each line with a form of its own starts at /submissions/<slug>/new (Nav,
// 2026-10-06; BRK-S311). The Exchange cards, the routes and the page titles all
// read this list, so a slug is named once. A line whose own form isn't built,
// or is switched off (the WC wizard, BRK-S301, behind VITE_ENABLE_WC_WIZARD),
// opens the shared intake there with the line's product picked. BOP takes
// "bop" once PMS has a BOP line.
export const NEW_SUBMISSION_LINES: readonly {
  slug: string;
  line: LineOfBusiness;
  title: string;
}[] = [
  {
    slug: "wc",
    line: "workers_compensation",
    title: "New Workers' Comp submission",
  },
  {
    slug: "gl",
    line: "general_liability",
    title: "New General Liability submission",
  },
];

/** Where a submission for this line starts: its own URL, else the shared intake. */
export function newSubmissionPath(line: LineOfBusiness): string {
  const own = NEW_SUBMISSION_LINES.find((l) => l.line === line);
  return own ? `/submissions/${own.slug}/new` : "/submissions/new";
}

/** Where a saved submission opens: a Workers' Comp one in its wizard while the
 *  wizard is on (BRK-S301), anything else on the shared detail. */
export function submissionPath(
  id: string,
  line: string | null | undefined,
  wcWizard: boolean = wcWizardEnabled(),
): string {
  return wcWizard && line === "workers_compensation"
    ? `/submissions/wc/${id}`
    : `/submissions/${id}`;
}
